import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b9ee2c84"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex gap-5 items-center" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "flex-1 flex flex-col justify-between gap-3" };
import { UIProgress, UITextLgMedium, UITextSmNormal } from '@gohighlevel/ghl-ui';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import dnsrecordLoadingStateImage from '../../../assets/svg/dnsrecordloadingstate.svg';
import providerLoadingStateImage from '../../../assets/svg/providerloadingstate.svg';
import retrievingLoadingStateImage from '../../../assets/svg/retrievingloadingstate.svg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectLoader',
    props: {
        loadingPercentage: null
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const imageData = computed(() => {
            if (props.loadingPercentage < 30) {
                return {
                    src: providerLoadingStateImage,
                    alt: t('findingProviderDetails'),
                    text: t('findingProviderDetails'),
                };
            }
            else if (props.loadingPercentage >= 30 && props.loadingPercentage < 70) {
                return {
                    src: dnsrecordLoadingStateImage,
                    alt: t('retrievingDNSRecord'),
                    text: t('retrievingDNSRecord'),
                };
            }
            else {
                return {
                    src: retrievingLoadingStateImage,
                    alt: t('finalizingSetup'),
                    text: t('finalizingSetup'),
                };
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("img", {
                            key: _unref(imageData).src,
                            src: _unref(imageData).src,
                            width: "96",
                            height: "97",
                            alt: _unref(imageData).alt
                        }, null, 8, _hoisted_2))
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(UITextLgMedium), null, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('settingUpDomain')), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(UIProgress), {
                        percentage: __props.loadingPercentage,
                        "indicator-placement": "outside",
                        "show-indicator": false,
                        type: "line",
                        processing: true
                    }, null, 8, ["percentage"]),
                    (_openBlock(), _createBlock(_unref(UITextSmNormal), {
                        key: _unref(imageData).text,
                        class: "animate-text"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(imageData).text), 1)
                        ]),
                        _: 1
                    }))
                ])
            ]));
        };
    }
});
